const INITIAL_CARD_ZONES = [
  { location: 'Boston', timeZone: 'America/New_York' },
  { location: 'New York', timeZone: 'America/New_York' }, 
  { location: 'Freiburg', timeZone: 'Europe/Berlin' },
  { location: 'Los Angeles', timeZone: 'America/Los_Angeles' },
  { location: 'Mumbai', timeZone: 'Asia/Kolkata' },
  { location: 'London', timeZone: 'Europe/London' },
  { location: 'Sydney', timeZone: 'Australia/Sydney' },
  { location: 'Shanghai', timeZone: 'Asia/Shanghai' },
  { location: 'US PT Pacific Time (C)', timeZone: 'America/Los_Angeles' },
  { location: 'US MT Mountain Time (C)', timeZone: 'America/Edmonton' },
  { location: 'US CT Central Time (C)', timeZone: 'America/Monterrey' },
  { location: 'US ET Eastern Time (C)', timeZone: 'America/New_York' },
  { location: 'Coordinated Universal Time (UTC) (C)', timeZone: 'UTC' },
  { location: 'Greenwich Mean Time (GMT) (C)', timeZone: 'GMT' }
]

export {INITIAL_CARD_ZONES}